// extracted by mini-css-extract-plugin
module.exports = {"consumption-linechart":"consumption-linechart--20V1W"};